import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store';
import axios from 'axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import hevueImgPreview from 'hevue-img-preview'
import VueLazyload from 'vue-lazyload'

import './directive'

import './assets/less/common.less'
import './assets/less/adapted.less'
import 'animate.css'

Vue.config.productionTip = false

Vue.use(hevueImgPreview)
Vue.use(VueLazyload)
Vue.use(ElementUI)

Vue.prototype.axios = axios
Vue.prototype.$store = store;
Vue.prototype.$bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store: store,
})



// WEBPACK FOOTER //
// ./src/main.js